// For Add Item to Cart
export const addCart = (product) =>{
    return {
        type:"ADDITEM",
        payload:product
    }
}

export const addOne = (product) =>{
    return {
        type:"ADDONE",
        payload:product
    }
}

// For Delete Item to Cart
export const delCart = (product) =>{
    return {
        type:"DELITEM",
        payload:product
    }
}

export const delAllCart = (product) =>{
    return {
        type:"DELALLITEM",
    }
}

export const delAllProduct = (product)=>{
    return{
        type:"DELALLQTY",
        payload:product
    }
}


export const refereshState = (product)=>{
    return{
        type:"REFERESH",
        payload:product
    }
}


export const addFavorite = (product) => {
    return {
      type: "ADD_FAVORITE",
      payload: product
    };
  };

  export const removeFavorite = (product) => {
    return {
      type: "REMOVE_FAVORITE",
      payload: product
    };
  };

  export const clearFavorites = () => {
    return {
      type: "CLEAR_FAVORITES"
    };
  };